import store from '@/store/store'

export default function retailerNotRequireAuth(to, from, next) {
  if (store.getters['retailerAuth/token']) {
    next('/retailer')
    return
  } else {
    next()
    return
  }
}
